import _regeneratorRuntime from "/root/app/node_modules/@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(performanceVinDataSaga),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(performanceVinListener);

import { put, takeLatest, select } from 'redux-saga/effects';
import get from 'lodash/get';
import createRequestSaga from '@signal/utils/createRequestSaga';
import api from '../api';
import { activeAccountIdSelector } from '../auth/selectors';
import { searchSelector } from '../router/selectors';
import { performanceVinDataActions, performanceVinDataLoad } from './actions';
import { isLoadedSelector } from './selectors';
export function performanceVinDataSaga(_ref) {
  var props, vin, search, accountId;
  return _regeneratorRuntime.wrap(function performanceVinDataSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          props = _ref.payload;
          vin = get(props, 'match.params.vin');
          _context.next = 4;
          return select(searchSelector);

        case 4:
          search = _context.sent;
          _context.next = 7;
          return select(activeAccountIdSelector);

        case 7:
          accountId = _context.sent;
          _context.next = 10;
          return put(api.get(performanceVinDataActions, "/attribution/".concat(accountId, "/vin/").concat(vin).concat(search, "&nopath"), {
            timeout: 30000
          }, {
            request: function request() {
              return {
                vin: vin
              };
            },
            success: function success(data) {
              return {
                vin: vin,
                data: data
              };
            },
            failure: function failure(error) {
              return {
                vin: vin,
                error: error
              };
            }
          }));

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export var loadPerformanceVinData = createRequestSaga(performanceVinDataActions, {
  loadedSelector: isLoadedSelector
});
export function performanceVinListener() {
  return _regeneratorRuntime.wrap(function performanceVinListener$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeLatest(performanceVinDataLoad.getType(), performanceVinDataSaga);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}